var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.userType === 1)?_c('div',{staticClass:"rank"},[((_vm.coin > 0))?_c('div',[_vm._v(" 第"),_c('span',[_vm._v(_vm._s(_vm.rank))]),_vm._v("名 ")]):((_vm.winnerCoin > 0))?_c('div',[_vm._v("进步奖")]):_vm._e()]):_c('div',{staticClass:"no-rank"},[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }